module.exports = __webpack_public_path__ + "static/media/customization.af7299d3.svg";